import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Editor, EditorState, convertFromRaw } from "draft-js";

const styleMap = {
  RED: { color: "#ff4646" },
  YELLOW: { color: "#ffc419" },
  GREEN: { color: "#16c48c" },
  BLUE: { color: "#5b9fc0" }
};

export default class RichParser extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = { editorState: this.getInitialEditorState() };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) this.reinitializeEditor();
  }

  getInitialEditorState = () =>
    this.props.value ? EditorState.createWithContent(convertFromRaw(JSON.parse(this.props.value))) : EditorState.createEmpty();

  reinitializeEditor = () => this.setState({ editorState: this.getInitialEditorState() });

  render() {
    return <Editor readonly customStyleMap={styleMap} editorState={this.state.editorState} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/RichEditor/RichParser.js